/**
 * Destination validation for the `navigation.*` slice capabilities.
 *
 * Kept free of Grove/router imports so the rule below stays pure and can be
 * exercised on its own — it is what holds slice navigation inside Grove.
 */

/**
 * Normalizes a slice-supplied Grove path and refuses anything that would leave
 * the origin. `//evil.com` and `/\evil.com` both look root-relative but resolve
 * to another host, so the check is on the resolved origin rather than the raw
 * string.
 */
export const resolveInternalPath = (path: string, origin: string): string => {
    if (!path.startsWith('/')) {
        throw new Error(
            `path must be a Grove route starting with "/" (got "${path}") — slices cannot link outside Grove`,
        );
    }

    const resolved = new URL(path, origin);

    if (resolved.origin !== new URL(origin).origin) {
        throw new Error(
            `path "${path}" resolves outside Grove — slices cannot link outside Grove`,
        );
    }

    return `${resolved.pathname}${resolved.search}${resolved.hash}`;
};
